import React, { FC, useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import LanguageSelect from '../../components/user/language/LanguageSelect';
import { useHistory, useParams } from 'react-router';
import useActivateAccount from '../../hooks/api/users/useActivateAccount';
import { useIntl } from 'react-intl';

const ActivateAccountPage: FC = () => {
  const intl = useIntl();
  const [success, setSuccess] = useState<boolean>(false);
  const { token } = useParams<{ token?: string | undefined }>();
  const { activateAccount, isLoading } = useActivateAccount();
  const history = useHistory();

  useEffect(() => {
    const activate = async () => {
      if (token) {
        const result = await activateAccount(token);
        setSuccess(result);
      }
    };
    activate();
  }, [token]);

  const renderElement = (message, button) => (
    <div>
      <div className="message">{message}</div>
      <Button onClick={() => history.replace('/login')} variant="primary">
        {button}
      </Button>
    </div>
  );

  return (
    <>
      <div className="background"></div>

      <Container fluid className="login-container activation-page">
        <div className="login-header">
          <img
            src="https://cache.kreezee.com/home/logos/flat_renverse_logo_kreezee_no_border.svg"
            alt="Kreezee Sports"
          />
          <LanguageSelect color="#fff" />
        </div>
        <Container className="kreezee-login-container py-5">
          {isLoading && (
            <span className="message">{intl.formatMessage({ id: 'activateAccountPage.activatingAccount' })}</span>
          )}
          {!isLoading &&
            success &&
            renderElement(
              intl.formatMessage({ id: 'activateAccountPage.activationSuccess' }),
              intl.formatMessage({ id: 'activateAccountPage.login' }),
            )}
          {!success &&
            !isLoading &&
            renderElement(
              intl.formatMessage({ id: 'activateAccountPage.activationFailure' }),
              intl.formatMessage({ id: 'activateAccountPage.backToLogin' }),
            )}
        </Container>
      </Container>
    </>
  );
};

export default ActivateAccountPage;
